// @vendors
const Immutable = require('immutable');

// @helpers
const actionTypes = require('constants/actionTypes');
const {
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    EURO_TEXT
} = require('constants/index');
const brokerWarrantsAdvancedBuyStep1 = require('./brokerWarrantsAdvancedBuy/brokerWarrantsAdvancedBuyStep1');
const brokerWarrantsAdvancedBuyStep2 = require('./brokerWarrantsAdvancedBuy/brokerWarrantsAdvancedBuyStep2');
const brokerWarrantsAdvancedBuyStep3 = require('./brokerWarrantsAdvancedBuy/brokerWarrantsAdvancedBuyStep3');

function setInitialState() {
    return Immutable.Map().merge({
        steps: [
            brokerWarrantsAdvancedBuyStep1(undefined, {type: null}),
            brokerWarrantsAdvancedBuyStep2(undefined, {type: null}),
            brokerWarrantsAdvancedBuyStep3(undefined, {type: null})
        ],
        visibleStep: 1,
        productCurrency: EURO_TEXT,
        willCancel: false,
        submitSuccessful: false,
        //ISIN of the warrant I'm buying
        isin: '',
        //ISO of the warrant I'm buying
        iso: '',
        validationServiceResponse: {},
        signaturePatternToken: '',
        error: ''
    });
}

function updateStep(index, steps, action) {
    return steps.update(index, step => {
        switch (index) {
            case FIRST_STEP:
                return brokerWarrantsAdvancedBuyStep1(step, action);
            case SECOND_STEP:
                return brokerWarrantsAdvancedBuyStep2(step, action);
            case THIRD_STEP:
                return brokerWarrantsAdvancedBuyStep3(step, action);
        }
    })
}

function brokerWarrantsAdvancedBuyReducer(state = setInitialState(), action) {
    let partialSteps;
    let visibleStep;

    switch (action.type) {
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_RESET:
            return setInitialState();
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_SET_VISIBLE_STEP:
            return state.set('visibleStep', action.payload.step);
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_VALIDATE_UI_STEP:
            switch (action.payload.step) {
                case WIZARD_FIRST_STEP:
                    partialSteps = updateStep(FIRST_STEP, state.get('steps'), action);
                    visibleStep = partialSteps.get(FIRST_STEP).get('valid') ? WIZARD_SECOND_STEP : WIZARD_FIRST_STEP;
                    return state.merge({
                        steps: partialSteps,
                        visibleStep
                    });
                case WIZARD_SECOND_STEP:
                    partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
                    return state.merge({
                        steps: partialSteps
                    });
                case WIZARD_THIRD_STEP:
                    partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
                    return state.merge({
                        steps: partialSteps
                    })
            }
            return state;
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_ORDER_TERMS_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_ORDER_CONDITION_VALUE_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_ORDER_CONDITION_TYPE_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_CONDITION_TYPE_VALUE_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_INPUT_SEARCH_PRODUCT_SELECTED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_ORDER_TERM_VALIDITY_DATE_CHANGED:
            partialSteps = updateStep(FIRST_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps
            });
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_STOCK_CONTRACT_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_TITLE_QUANTITY_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_FOR_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_LIMITED_VALUE_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_VALIDITY_DATE_CHANGED:
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_APPROX_IMPORT_CHANGED:
            partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps
            });
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_WILL_CANCEL:
            return state.merge({
                willCancel: action.payload.value
            });
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_FINISH:
            return state;
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_VALIDATE_REQUEST:
            switch (action.payload.step) {
                case WIZARD_FIRST_STEP:
                case WIZARD_THIRD_STEP:
                    return state;
                case WIZARD_SECOND_STEP:
                    partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
                    return state.merge({
                        steps: partialSteps
                    });
            }
            return state;
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_VALIDATE_SUCCESS:
            switch (action.payload.step) {
                case WIZARD_FIRST_STEP:
                case WIZARD_THIRD_STEP:
                    return state;
                case WIZARD_SECOND_STEP:
                    partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
                    return state.merge({
                        steps: partialSteps,
                        visibleStep: WIZARD_THIRD_STEP,
                        validationServiceResponse: action.payload.data
                    });
            }
            return state;
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_VALIDATE_FAILURE:
            switch (action.payload.step) {
                case WIZARD_FIRST_STEP:
                case WIZARD_THIRD_STEP:
                    return state;
                case WIZARD_SECOND_STEP:
                    partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
                    return state.merge({
                        steps: partialSteps,
                        error: action.payload.data.error
                    });
            }
            return state;
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_SET_ORDER_ID:
            return state.merge({
                isin: action.payload.isin,
                iso: action.payload.iso
            });
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_SIGNATURE_SUCCESS:
            return state.set('signaturePatternToken', action.payload.token);
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_CONFIRM_REQUEST:
            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps
            });
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_CONFIRM_SUCCESS:
            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
                submitSuccessful: true
            });
        case actionTypes.BROKER_WARRANTS_ADVANCED_BUY_CONFIRM_FAILURE:
            partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
            return state.merge({
                steps: partialSteps,
                error: action.payload.data.error
            });
        default:
            return state
    }
}

module.exports = brokerWarrantsAdvancedBuyReducer;
